"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMultiDimensional = void 0;
/**
 * The DOM's `getImageData` API returns one-dimensional pixel arrays that are
 * hard to use in application code: [r, g, b, a, r, g, b, a, ...]. This helper
 * transforms those into a more usable structure: `grid[row][col] = [r, g, b, a]`
 */
function makeMultiDimensional(pixels, gridSize) {
    var area = [];
    for (var i = 0; i < gridSize; i++) {
        area[i] = [];
    }
    var sliceStartIndex = 0;
    for (var row = 0; row < gridSize; row++) {
        for (var col = 0; col < gridSize; col++) {
            area[row][col] = pixels.slice(sliceStartIndex, sliceStartIndex + 4);
            sliceStartIndex += 4;
        }
    }
    return area;
}
exports.makeMultiDimensional = makeMultiDimensional;
//# sourceMappingURL=makeMultiDimensional.js.map